import { ReferenceType } from '../_enums/referenceType';
import { expandCamelCase } from './camelCaseHelper';
export function getReferenceTypeName(refType: ReferenceType) {
    let s: string = expandCamelCase(ReferenceType[refType]).toString();
    return s;
}